<div #parent id="right-sidebar-parent" class="right-sidebar-{{ displayMode }}">
  <div id="right-drag-bar" class="right-drag-bar"
    appResize
    [parent]="parent"
    [mixSize]="360"
    [maxSizePercentage]="50"
    right-to-left
  ></div>
  @switch (flowState$ | async) {
    @case ('PREVIEW_MODE') {
      <app-preview (updateFlow)="updateFlowHandler($event)"></app-preview>
    }
    @default {
      @switch (right_sidebar_display) {
        @case ('NEW') {
          <app-new-node></app-new-node>
        }
        @case ('EDIT') {
          @if (deli) {
            <node-delegator
              (saveNode)="saveNodeClicked($event)"
              (deleteNode)="deleteNodeClicked($event)"
              (resetNode)="resetNode.emit()"
              [stepInfo]="data"
              [isRecycleBin]="isRecycle"
              [currentFlowSteps]="currentFlowSteps"
            ></node-delegator>
          }
        }
        @default {
          <app-new-node ></app-new-node>
        }
      }
    }
  }
</div>


@if (!!activeFormService.focus && !activeFormService.isReadOnly) {
  <app-variable
    [topPosition]="activeFormService.topPosition"
  ></app-variable>
}
